module.exports = __webpack_public_path__ + "media/yupchat-notification.ec28d452.mp3";